const URL_BACKEND = process.env.VUE_APP_URL_BACKEND;
import axios from "@/lib/axioxAppli";
import * as types from "./mutation_types";

export const retrieve = ({ commit }, values) => {
  commit(types.STRUCTURE_SHOW_TOGGLE_LOADING);
  axios
    .get(
      URL_BACKEND +
        "api-structure/cartes/" +
        values.robId +
        "/" +
        values.structureId +
        "/"
    )
    .then((response) => {
      commit(types.STRUCTURE_SHOW_TOGGLE_LOADING);
      commit(types.STRUCTURE_SHOW_SET_RETRIEVED, response.data);
    })
    .catch((e) => {
      commit(types.STRUCTURE_SHOW_TOGGLE_LOADING);
      commit(types.STRUCTURE_SHOW_SET_ERROR, e.message);
    });
};

export const reset = ({ commit }) => {
  commit(types.STRUCTURE_SHOW_RESET);
};
